/* eslint-disable */
import React, { createContext, useState } from 'react';
import { BracketData, DropDownData, Loader, SubDeptData, UserInfo } from '../../shared/interface/CostBasedPricingInterface';
import { getZoneBasedPricingDetails } from '../../../api/user';
import { ZoneBasedPricingHeading } from '../../../constants/constants';
import { ZoneBasedFormData, ErrorMessage } from '../../shared/interface/ZoneBasedPricingInterface';
// import { getZoneBasedPricingDetails } from '../../../api/user';
export const ZoneBasedPricingContext = createContext<any>('');

export function ZoneBasedPricingProvider(props: any) {
    const [zoneBasedPricingSearchData, setZoneBasedPricingSearchData] = useState<any>({
        zone: '',
        department: '',
        subdepartment: '',
        bracket: ''
    })
    const [zoneSelected, setZoneSelected] = useState([]);
    const [formZoneSelected, setFormZoneSelected] = useState([]);
    const [zoneOptions, setZoneOptions] = useState<DropDownData[]>([{
        label: "Select",
        value: "",
    }]);
    const [deptOptions, setDeptOptions] = useState<DropDownData[]>([{
        label: "Select",
        value: "",
    }]);
    const [subDeptOptions, setsubDeptOptions] = useState<SubDeptData[]>([{
        label: "Select",
        value: "",
        departmentnumber: ''
    }]);
    const [bracketOptions, setbracketOptions] = useState<BracketData[]>([{
        label: "Select",
        value: "",
        subdepartmentnumber: ''
    }]);
    const [deptFormOptions, setDeptFormOptions] = useState<DropDownData[]>([{
        label: "Select",
        value: "",
    }]);
    const [subDeptFormOptions, setsubDeptFormOptions] = useState<SubDeptData[]>([{
        label: "Select",
        value: "",
        departmentnumber: ''
    }]);
    const [bracketFormOptions, setbracketFormOptions] = useState<BracketData[]>([{
        label: "Select",
        value: "",
        subdepartmentnumber: ''
    }]);
    const [loader, setLoader] = useState<Loader>({
        dropdownLoader: false,
        contentLoader: false,
        mainPage: false
    })
    const [dropDownData, setDropDownData] = useState<any>({})
    const [pageDisplay, setPageDisplay] = useState<Number>(0);
    const [displayGrid, setDisplayGrid] = useState<boolean>(false);
    const [displayForm, setDisplayForm] = useState<boolean>(false);
    const [formProps, setFormProps] = useState(undefined);
    const [zoneBasedPricingGridContent, setZoneBasedPricingGridContent] = useState<any[]>([]);
    const [gridHeaders, setGridHeaders] = useState(ZoneBasedPricingHeading);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [checked, setChecked] = useState<boolean>(false);
    const [pricingQueueId, setPricingQueueId] = useState('');
    const zoneBasedFormData = {
        zoneNumber: '',
        departmentNumber: '',
        subdepartmentNumber: '',
        bracketNumber: '',
        termPrem: '',
        turn: '',
        reCalculateTerm: '',
        newAndUsedRatePrem: '',
        brandNewRatePrem: '',
        startDate: '',
        endDate: '2099-12-31',
        publishPriceForExisitingRMS: '',
        schedule: ''
    }
    const [zoneBasedPricingFormData, setZoneBasedPricingFormData] = useState<ZoneBasedFormData>(zoneBasedFormData)
    const [errorMessage, setErrorMessage] = useState<ErrorMessage>({
        startDate: '',
        endDate: '',
    })
    const [handlePopup, setHandlePopup] = useState({
        isOpen: false,
        Content: '',
        index: 0,
        type: ''
    })
    const [userInfo, setUserInfo] = useState<UserInfo>({
        emailId: '',
        employeeId: '',
        userName: '',
        companyCode: [],
        hasApproveAccess: false,
        hasEditAccess: false,
        isFranchiseeUser: false
    })
    const searchZoneBasedPricingDetails = async (offset: string = '1') => {
        try {
            setDisplayGrid(true);
            setLoader({ ...loader, contentLoader: true });
            const request = {
                zoneNumber: zoneBasedPricingSearchData.zone?.length !== dropDownData?.zone?.length ?
                    zoneBasedPricingSearchData.zone : undefined,
                departmentNumber: zoneBasedPricingSearchData.department,
                subdepartmentNumber: zoneBasedPricingSearchData.subdepartment || null,
                bracketNumber: zoneBasedPricingSearchData.bracket || null,
                companyCode: ((userInfo.isFranchiseeUser) && ((zoneBasedPricingSearchData.zone == undefined) ||
                    (zoneBasedPricingSearchData.zone?.length == dropDownData?.zone?.length))) ? userInfo.companyCode : undefined,
                offset: offset,
                limit: '25',
            }
            setTotalRowCount(0);
            console.log(request, 'request in search fn')
            const searchResponse: any = await getZoneBasedPricingDetails(request);
            setLoader({ ...loader, contentLoader: false });
            if (searchResponse.status == 200 && searchResponse.data) {
                setPageDisplay(200)
                setTotalRowCount(searchResponse.data.totalRecordsCount)
                setZoneBasedPricingGridContent(searchResponse.data.zonePricingRuleDetails)
                setPageCount(Math.ceil(searchResponse.data.totalRecordsCount / 25));
            } else if ((searchResponse.status == 200 && !searchResponse.data) || searchResponse.status == 204) {
                setPageDisplay(204)
            }
            else if (searchResponse.status == 400) {
                setPageDisplay(400)
            }
            else {
                setPageDisplay(500)
            }

        }
        catch (e) {
            setPageDisplay(500)
        }
    }

    return (
        <div>
            <ZoneBasedPricingContext.Provider
                value={{
                    zoneBasedPricingSearchData, setZoneBasedPricingSearchData,
                    deptOptions, setDeptOptions, subDeptOptions, setsubDeptOptions,
                    bracketOptions, setbracketOptions, zoneOptions, loader, setLoader,
                    dropDownData, setDropDownData, pageDisplay, setPageDisplay,
                    zoneBasedPricingGridContent, setZoneBasedPricingGridContent,
                    displayGrid, setDisplayGrid, displayForm, setDisplayForm,
                    zoneBasedPricingFormData, setZoneBasedPricingFormData,
                    formProps, setFormProps, gridHeaders, setGridHeaders,
                    totalRowCount, setTotalRowCount, pageNumber, setPageNumber,
                    pageCount, setPageCount, searchZoneBasedPricingDetails,
                    errorMessage, setErrorMessage, pricingQueueId, setPricingQueueId,
                    zoneBasedFormData, handlePopup, setHandlePopup, userInfo, setUserInfo,
                    setZoneOptions, zoneSelected, setZoneSelected, formZoneSelected, setFormZoneSelected,
                    checked, setChecked, deptFormOptions, setDeptFormOptions, subDeptFormOptions, setsubDeptFormOptions,
                    bracketFormOptions, setbracketFormOptions
                }}
            >
                {props.children}
            </ZoneBasedPricingContext.Provider>
        </div>
    );
}
